export default __webpack_public_path__ + "97b49c457f29c816c0d56d7f310576e6.png";